export default {
  blood: [
    {
      cancer: 'Breast cancer', tissue: 'Circulating tumor cells(CTCs)', baseFileName: 'Breast.cancer-CTCs', exprLevelRNATypes: 'mRNA,lncRNA', diffExprRNATypes: 'mRNA,lncRNA',
    },
    {
      cancer: 'Breast cancer', tissue: 'Blood', baseFileName: 'Breast.cancer-blood', exprLevelRNATypes: 'miRNA', diffExprRNATypes: 'miRNA',
    },
    {
      cancer: 'Prostate cancer', tissue: 'Extracellular vesicles(EVs)', baseFileName: 'Prostate.cancer-EVs', exprLevelRNATypes: 'miRNA,piRNA,tRFRNA', diffExprRNATypes: 'miRNA,piRNA,tRFRNA',
    },
    {
      cancer: 'Pancreatic cancer', tissue: 'Extracellular vesicles(EVs)', baseFileName: 'Pancreatic.cancer-EVs', exprLevelRNATypes: 'mRNA,lncRNA,circRNA,miRNA,piRNA,tRFRNA', diffExprRNATypes: 'mRNA,lncRNA,circRNA,miRNA,piRNA,tRFRNA',
    },
    {
      cancer: 'Pancreatic cancer', tissue: 'Blood', baseFileName: 'Pancreatic.cancer-blood', exprLevelRNATypes: 'miRNA', diffExprRNATypes: 'miRNA',
    },
    {
      cancer: 'Ovarian cancer', tissue: 'Blood', baseFileName: 'Ovarian.cancer-blood', exprLevelRNATypes: 'miRNA', diffExprRNATypes: 'miRNA',
    },
    {
      cancer: 'Multiple Myeloma', tissue: 'Extracellular vesicles(EVs)', baseFileName: 'Multiple.Myeloma-EVs', exprLevelRNATypes: 'miRNA,piRNA,tRFRNA', diffExprRNATypes: 'miRNA,piRNA,tRFRNA',
    },
    {
      cancer: 'Multiple Myeloma', tissue: 'Blood', baseFileName: 'Multiple.Myeloma-blood', exprLevelRNATypes: 'miRNA', diffExprRNATypes: 'miRNA',
    },
    {
      cancer: 'Lung cancer', tissue: 'Blood', baseFileName: 'Lung.cancer-blood', exprLevelRNATypes: 'mRNA,lncRNA,miRNA', diffExprRNATypes: 'mRNA,lncRNA,miRNA',
    },
    {
      cancer: 'Liver cancer', tissue: 'Extracellular vesicles(EVs)', baseFileName: 'Liver.cancer-EVs', exprLevelRNATypes: 'mRNA,lncRNA,circRNA', diffExprRNATypes: 'mRNA,lncRNA,circRNA',
    },
    {
      cancer: 'Liver cancer', tissue: 'Blood', baseFileName: 'Liver.cancer-blood', exprLevelRNATypes: 'miRNA', diffExprRNATypes: 'miRNA',
    },
    {
      cancer: 'Glioblastoma', tissue: 'Extracellular vesicles(EVs)', baseFileName: 'Glioblastoma-EVs', exprLevelRNATypes: 'mRNA,lncRNA,miRNA', diffExprRNATypes: 'mRNA,lncRNA,miRNA',
    },
    {
      cancer: 'Gastric cancer', tissue: 'Blood', baseFileName: 'Gastric.cancer-blood', exprLevelRNATypes: 'miRNA', diffExprRNATypes: 'miRNA',
    },
    {
      cancer: 'Esophageal cancer', tissue: 'Blood', baseFileName: 'Esophageal.cancer-blood', exprLevelRNATypes: 'miRNA', diffExprRNATypes: 'miRNA',
    },
    {
      cancer: 'Colorectal cancer', tissue: 'Blood', baseFileName: 'Colorectal.cancer-blood', exprLevelRNATypes: 'mRNA,lncRNA,miRNA', diffExprRNATypes: 'mRNA,lncRNA,miRNA',
    },
    {
      cancer: 'Colorectal cancer', tissue: 'Extracellular vesicles(EVs)', baseFileName: 'Colorectal.cancer-EVs', exprLevelRNATypes: 'mRNA,lncRNA,circRNA,miRNA,piRNA,tRFRNA', diffExprRNATypes: 'mRNA,lncRNA,circRNA,miRNA,piRNA,tRFRNA',
    },
    {
      cancer: 'Borderline ovarian tumor', tissue: 'Blood', baseFileName: 'Borderline.ovarian.tumor-blood', exprLevelRNATypes: 'miRNA', diffExprRNATypes: 'miRNA',
    },
    {
      cancer: 'Wilms Tumor', tissue: 'Blood', baseFileName: 'Wilms.tumor-blood', exprLevelRNATypes: 'miRNA', diffExprRNATypes: 'miRNA',
    },
    {
      cancer: 'Sarcoma', tissue: 'Blood', baseFileName: 'Sarcoma-blood', exprLevelRNATypes: 'miRNA', diffExprRNATypes: 'miRNA',
    },
    {
      cancer: 'Renal cellcar cinoma', tissue: 'Extracellular vesicles(EVs)', baseFileName: 'Renal.cellcar.cinoma-EVs', exprLevelRNATypes: 'miRNA,piRNA,tRFRNA', diffExprRNATypes: 'miRNA,piRNA,tRFRNA',
    },
    {
      cancer: 'Normal person', tissue: 'Blood', baseFileName: 'Normal.person-blood', exprLevelRNATypes: 'mRNA,lncRNA,miRNA', diffExprRNATypes: '',
    },
    {
      cancer: 'Normal person', tissue: 'Circulating tumor cells(CTCs)', baseFileName: 'Normal.person-CTCs', exprLevelRNATypes: 'mRNA,lncRNA,miRNA', diffExprRNATypes: '',
    },
    {
      cancer: 'Normal person', tissue: 'Extracellular vesicles(EVs)', baseFileName: 'Normal.person-EVs', exprLevelRNATypes: 'mRNA,lncRNA,circRNA,miRNA,piRNA,tRFRNA', diffExprRNATypes: '',
    },
  ],
  tissue: [
    {
      cancer: 'Breast cancer', tissue: 'Normal tissue', baseFileName: 'Breast.cancer-normal', exprLevelRNATypes: 'mRNA,lncRNA,miRNA,piRNA,tRFRNA', diffExprRNATypes: '',
    },
    {
      cancer: 'Breast cancer', tissue: 'Tumor tissue', baseFileName: 'Breast.cancer-tumor', exprLevelRNATypes: 'mRNA,lncRNA,miRNA,piRNA,tRFRNA', diffExprRNATypes: 'miRNA,lncRNA,miRNA,piRNA,tRFRNA',
    },
    {
      cancer: 'Prostate cancer', tissue: 'Normal tissue', baseFileName: 'Prostate.cancer-normal', exprLevelRNATypes: 'mRNA,lncRNA,miRNA,piRNA,tRFRNA', diffExprRNATypes: '',
    },
    {
      cancer: 'Prostate cancer', tissue: 'Tumor tissue', baseFileName: 'Prostate.cancer-tumor', exprLevelRNATypes: 'mRNA,lncRNA,miRNA,piRNA,tRFRNA', diffExprRNATypes: 'mRNA,lncRNA,miRNA,piRNA,tRFRNA',
    },
    {
      cancer: 'Pancreatic cancer', tissue: 'Normal tissue', baseFileName: 'Pancreatic.cancer-normal', exprLevelRNATypes: 'mRNA,lncRNA,miRNA', diffExprRNATypes: '',
    },
    {
      cancer: 'Pancreatic cancer', tissue: 'Tumor tissue', baseFileName: 'Pancreatic.cancer-tumor', exprLevelRNATypes: 'mRNA,lncRNA,miRNA', diffExprRNATypes: 'mRNA,lncRNA,miRNA',
    },
    {
      cancer: 'Ovarian cancer', tissue: 'Normal tissue', baseFileName: 'Ovarian.cancer-normal', exprLevelRNATypes: 'miRNA', diffExprRNATypes: '',
    },
    {
      cancer: 'Ovarian cancer', tissue: 'Tumor tissue', baseFileName: 'Ovarian.cancer-tumor', exprLevelRNATypes: 'miRNA', diffExprRNATypes: 'miRNA',
    },
    {
      cancer: 'Multiple Myeloma', tissue: 'Normal tissue', baseFileName: 'Multiple.Myeloma-normal', exprLevelRNATypes: 'miRNA,piRNA,tRFRNA', diffExprRNATypes: '',
    },
    {
      cancer: 'Multiple Myeloma', tissue: 'Tumor tissue', baseFileName: 'Multiple.Myeloma-tumor', exprLevelRNATypes: 'miRNA,piRNA,tRFRNA', diffExprRNATypes: 'miRNA,piRNA,tRFRNA',
    },
    {
      cancer: 'Lung cancer', tissue: 'Normal tissue', baseFileName: 'Lung.cancer-normal', exprLevelRNATypes: 'mRNA,lncRNA,miRNA', diffExprRNATypes: '',
    },
    {
      cancer: 'Lung cancer', tissue: 'Tumor tissue', baseFileName: 'Lung.cancer-tumor', exprLevelRNATypes: 'mRNA,lncRNA,miRNA', diffExprRNATypes: 'mRNA,lncRNA,miRNA',
    },
    {
      cancer: 'Liver cancer', tissue: 'Normal tissue', baseFileName: 'Liver.cancer-normal', exprLevelRNATypes: 'mRNA,lncRNA,miRNA', diffExprRNATypes: '',
    },
    {
      cancer: 'Liver cancer', tissue: 'Tumor tissue', baseFileName: 'Liver.cancer-tumor', exprLevelRNATypes: 'mRNA,lncRNA,miRNA', diffExprRNATypes: 'mRNA,lncRNA,miRNA',
    },
    {
      cancer: 'Liver cancer', tissue: 'Precancerous lesion', baseFileName: 'Liver.cancer-precancerous.lesion', exprLevelRNATypes: 'mRNA,lncRNA', diffExprRNATypes: 'mRNA,lncRNA',
    },
    {
      cancer: 'Glioblastoma', tissue: 'Normal tissue', baseFileName: 'Glioblastoma-normal', exprLevelRNATypes: 'mRNA,lncRNA,miRNA', diffExprRNATypes: '',
    },
    {
      cancer: 'Glioblastoma', tissue: 'Tumor tissue', baseFileName: 'Glioblastoma-tumor', exprLevelRNATypes: 'mRNA,lncRNA,miRNA', diffExprRNATypes: 'mRNA,lncRNA,miRNA',
    },
    {
      cancer: 'Gastric cancer', tissue: 'Normal tissue', baseFileName: 'Gastric.cancer-normal', exprLevelRNATypes: 'miRNA', diffExprRNATypes: '',
    },
    {
      cancer: 'Gastric cancer', tissue: 'Tumor tissue', baseFileName: 'Gastric.cancer-tumor', exprLevelRNATypes: 'miRNA', diffExprRNATypes: 'miRNA',
    },
    {
      cancer: 'Gastric cancer', tissue: 'Precancerous lesion', baseFileName: 'Gastric.cancer-precancerous.lesion', exprLevelRNATypes: 'mRNA,lncRNA', diffExprRNATypes: 'mRNA,lncRNA',
    },
    {
      cancer: 'Esophageal cancer', tissue: 'Normal tissue', baseFileName: 'Esophageal.cancer-normal', exprLevelRNATypes: 'miRNA', diffExprRNATypes: '',
    },
    {
      cancer: 'Esophageal cancer', tissue: 'Tumor tissue', baseFileName: 'Esophageal.cancer-tumor', exprLevelRNATypes: 'miRNA', diffExprRNATypes: 'miRNA',
    },
    {
      cancer: 'Esophageal cancer', tissue: 'Precancerous lesion', baseFileName: 'Esophageal.cancer-precancerous.lesion', exprLevelRNATypes: 'mRNA,lncRNA', diffExprRNATypes: 'mRNA,lncRNA',
    },
    {
      cancer: 'Colorectal cancer', tissue: 'Normal tissue', baseFileName: 'Colorectal.cancer-normal', exprLevelRNATypes: 'mRNA,lncRNA,miRNA,piRNA,tRFRNA', diffExprRNATypes: '',
    },
    {
      cancer: 'Colorectal cancer', tissue: 'Tumor tissue', baseFileName: 'Colorectal.cancer-tumor', exprLevelRNATypes: 'mRNA,lncRNA,miRNA,piRNA,tRFRNA', diffExprRNATypes: 'mRNA,lncRNA,miRNA,piRNA,tRFRNA',
    },
    {
      cancer: 'Colorectal cancer', tissue: 'Precancerous lesion', baseFileName: 'Colorectal.cancer-precancerous.lesion', exprLevelRNATypes: 'mRNA,lncRNA', diffExprRNATypes: 'mRNA,lncRNA',
    },
    {
      cancer: 'Wilms Tumor', tissue: 'Normal tissue', baseFileName: 'Wilms.tumor-normal', exprLevelRNATypes: 'miRNA', diffExprRNATypes: '',
    },
    {
      cancer: 'Wilms Tumor', tissue: 'Tumor tissue', baseFileName: 'Wilms.tumor-tumor', exprLevelRNATypes: 'miRNA', diffExprRNATypes: 'miRNA',
    },
    {
      cancer: 'Renal cellcar cinoma', tissue: 'Normal tissue', baseFileName: 'Renal.cellcar.cinoma-normal', exprLevelRNATypes: 'miRNA,piRNA,tRFRNA', diffExprRNATypes: '',
    },
    {
      cancer: 'Renal cellcar cinoma', tissue: 'Tumor tissue', baseFileName: 'Renal.cellcar.cinoma-tumor', exprLevelRNATypes: 'miRNA,piRNA,tRFRNA', diffExprRNATypes: 'miRNA,piRNA,tRFRNA',
    },

  ],
};
